import React, { memo, useEffect } from "react";
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import TextFieldForm from "./TextFieldForm";
import { useFormContext, Controller } from "react-hook-form";

import * as yup from 'yup';

const PhoneInput = ({ name, isRequired, defaultValue, ...rest }) => {
    const { t } = useTranslation();
    const { control, trigger, setValue } = useFormContext();


    const requiredSchema = yup
        .string()
        .when('$isRequired', ([isRequired], schema) =>
            isRequired ? 
                schema.required(t('application.errors.fieldRequired')) :
                schema
    );

    const validateField = async (value) => {
        try {
            await requiredSchema.validate(value, { context: { isRequired } });
        } catch (error) {
            return error.message;
        }
        return true;
    }

    useEffect(() => {
        if (defaultValue) {
            setValue(name, defaultValue);
        }
    }, [defaultValue]);

    return (
        <StyledPhoneWrapper
            className='phone-input'
        >
            <Controller
                name={name}
                control={control}
                defaultValue=''
                rules={{ validate: validateField }}
                render={({ field, fieldState }) => (
                    <TextFieldForm
                        {...rest}
                        onChange={(ev) => {
                            let val = ev.target.value.replace(/[^\d. +()-]/g, '');
                            field.onChange(val);
                        }}
                        error={fieldState.error}
                        isRequired={isRequired}
                        value={field.value || ''}
                        type="tel"
                        onBlur={(ev) => {
                            trigger(field.name);
                            field.onBlur(ev);
                        }}
                        ref={field.ref}
                    />
                )}
            />
        </StyledPhoneWrapper>
    );
};

export default memo(PhoneInput);

const StyledPhoneWrapper = styled.div``;